import React, { FC } from 'react';
import styled from 'styled-components';
import { ToolType } from '../../types';

// Import images for each tool
import adGenerator1 from 'assets/images/aistudio/empty_state/AD Generator - 1.png';
import adGenerator2 from 'assets/images/aistudio/empty_state/AD Generator - 2.png';
import multiFusion1 from 'assets/images/aistudio/empty_state/Multi Image Fusion new - 1.png';
import multiFusion2 from 'assets/images/aistudio/empty_state/Multi Image Fusion new - 2.png';
import magicSwap1 from 'assets/images/aistudio/empty_state/Product Transformer - 1.png';
import magicSwap2 from 'assets/images/aistudio/empty_state/Product Transformer - 2.png';
import staging1 from 'assets/images/aistudio/empty_state/Staging new - 1.png';
import staging2 from 'assets/images/aistudio/empty_state/Staging new - 2.png';
import staging3 from 'assets/images/aistudio/empty_state/Staging new - 3.png';
import tryon1 from 'assets/images/aistudio/empty_state/Tryon - 1.png';

import tryon2 from 'assets/images/aistudio/empty_state/Tryon - 2.png';
import tryon3 from 'assets/images/aistudio/empty_state/Tryon - 3.png';
import upscaler1 from 'assets/images/aistudio/empty_state/Upscaler centered.png';
import textTo3dLeft from 'assets/images/aistudio/empty_state/text_to_3d_left.png';
import textTo3dRight from 'assets/images/aistudio/empty_state/text_to_3d_right.png';
import imageTo3dLeft from 'assets/images/aistudio/empty_state/image_to_3d_left.png';
import imageTo3dRight from 'assets/images/aistudio/empty_state/image_to_3d_right.png';
import multiViewTo3dLeft from 'assets/images/aistudio/empty_state/multi_view_to_3d_left.png';
import multiViewTo3dRight from 'assets/images/aistudio/empty_state/multi_view_to_3d_right.png';
import videoGenerator1 from 'assets/images/aistudio/empty_state/Video Generator - 1.png';
import videoGenerator2 from 'assets/images/aistudio/empty_state/Video Generator - 2.png';

/* ============================================================
   INLINE SVG COMPONENTS (to avoid @svgr/webpack SVGO issues)
   ============================================================ */

const ArrowSingle: FC = () => (
    <svg width='100' height='127' viewBox='0 0 100 127' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M93 117.5L99 122L93 126.5' stroke='#A754F7' strokeLinecap='round' />
        <path d='M0 0.5H9.5C31.5914 0.5 49.5 18.4086 49.5 40.5V51.5' stroke='#A754F7' strokeDasharray='2 2' />
        <rect x='39' y='51' width='20' height='20' rx='10' fill='url(#arrow_grad)' />
        <g clipPath='url(#arrow_clip)'>
            <mask id='arrow_mask' style={{ maskType: 'luminance' }} maskUnits='userSpaceOnUse' x='43' y='55' width='12' height='12'>
                <path d='M55 55H43V67H55V55Z' fill='white' />
            </mask>
            <g mask='url(#arrow_mask)'>
                <path
                    d='M47.2422 55.375C47.2422 58.3439 45.6377 61 43.375 61C45.6377 61 47.2422 63.6563 47.2422 66.625C47.2422 63.6563 48.8466 61 51.1094 61C48.8466 61 47.2422 58.3439 47.2422 55.375Z'
                    fill='white'
                />
                <path
                    d='M51.8126 61C51.8126 62.4847 51.0107 63.8125 49.8789 63.8125C51.0107 63.8125 51.8126 65.1408 51.8126 66.625C51.8126 65.1408 52.6146 63.8125 53.7463 63.8125C52.6146 63.8125 51.8126 62.4847 51.8126 61Z'
                    fill='white'
                />
                <path
                    d='M52.6915 55.375C52.6915 56.8594 51.8896 58.1875 50.7578 58.1875C51.8894 58.1875 52.6915 59.5158 52.6915 61C52.6915 59.5158 53.4935 58.1875 54.6252 58.1875C53.4935 58.1875 52.6915 56.8594 52.6915 55.375Z'
                    fill='white'
                />
            </g>
        </g>
        <path d='M98.5 122H89C66.9086 122 49 104.091 49 82V71' stroke='#A754F7' strokeLinecap='round' />
        <defs>
            <linearGradient id='arrow_grad' x1='39' y1='51' x2='59' y2='71' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#843FEF' />
                <stop offset='0.5' stopColor='#A754F7' />
                <stop offset='1' stopColor='#DD4BAE' />
            </linearGradient>
            <clipPath id='arrow_clip'>
                <rect width='12' height='12' fill='white' transform='translate(43 55)' />
            </clipPath>
        </defs>
    </svg>
);

const ArrowTryon: FC = () => (
    <svg width='101' height='95' viewBox='0 0 101 95' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='40' y='40.5' width='21' height='21' rx='10.5' fill='url(#tryon_grad)' />
        <g clipPath='url(#tryon_clip)'>
            <mask id='tryon_mask' style={{ maskType: 'luminance' }} maskUnits='userSpaceOnUse' x='44' y='45' width='12' height='12'>
                <path d='M56 45H44V57H56V45Z' fill='white' />
            </mask>
            <g mask='url(#tryon_mask)'>
                <path
                    d='M48.2422 45.375C48.2422 48.3439 46.6378 51 44.375 51C46.6378 51 48.2422 53.6563 48.2422 56.625C48.2422 53.6563 49.8466 51 52.1094 51C49.8466 51 48.2422 48.3439 48.2422 45.375Z'
                    fill='white'
                />
                <path
                    d='M52.8126 51C52.8126 52.4847 52.0107 53.8125 50.8789 53.8125C52.0107 53.8125 52.8126 55.1408 52.8126 56.625C52.8126 55.1408 53.6146 53.8125 54.7463 53.8125C53.6146 53.8125 52.8126 52.4847 52.8126 51Z'
                    fill='white'
                />
                <path
                    d='M53.6915 45.375C53.6915 46.8594 52.8896 48.1875 51.7578 48.1875C52.8894 48.1875 53.6915 49.5158 53.6915 51C53.6915 49.5158 54.4935 48.1875 55.6252 48.1875C54.4935 48.1875 53.6915 46.8594 53.6915 45.375Z'
                    fill='white'
                />
            </g>
        </g>
        <path d='M51 41.2915L51 40.4998C51 18.4085 33.0914 0.499837 11 0.499838L-2.16371e-06 0.499838' stroke='#A754F7' strokeDasharray='2 2' />
        <path d='M100 89.5H79C63.536 89.5 51 76.964 51 61.5' stroke='#A754F7' strokeWidth='2' strokeLinecap='round' />
        <path d='M94 85L100 89.5L94 94' stroke='#A754F7' strokeLinecap='round' />
        <defs>
            <linearGradient id='tryon_grad' x1='40' y1='40.5' x2='61' y2='61.5' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#843FEF' />
                <stop offset='0.5' stopColor='#A754F7' />
                <stop offset='1' stopColor='#DD4BAE' />
            </linearGradient>
            <clipPath id='tryon_clip'>
                <rect width='12' height='12' fill='white' transform='translate(44 45)' />
            </clipPath>
        </defs>
    </svg>
);

const LabelAi: FC = () => (
    <svg width='98' height='24' viewBox='0 0 82 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect width='82' height='20' rx='4' fill='url(#label_grad)' />
        <g clipPath='url(#label_clip)'>
            <mask id='label_mask' style={{ maskType: 'luminance' }} maskUnits='userSpaceOnUse' x='4' y='4' width='12' height='12'>
                <path d='M16 4H4V16H16V4Z' fill='white' />
            </mask>
            <g mask='url(#label_mask)'>
                <path
                    d='M8.24219 4.375C8.24219 7.34387 6.63775 10 4.375 10C6.63775 10 8.24219 12.6563 8.24219 15.625C8.24219 12.6563 9.8466 10 12.1094 10C9.8466 10 8.24219 7.34387 8.24219 4.375Z'
                    fill='white'
                />
                <path
                    d='M12.8126 10C12.8126 11.4847 12.0107 12.8125 10.8789 12.8125C12.0107 12.8125 12.8126 14.1408 12.8126 15.625C12.8126 14.1408 13.6146 12.8125 14.7463 12.8125C13.6146 12.8125 12.8126 11.4847 12.8126 10Z'
                    fill='white'
                />
                <path
                    d='M13.6915 4.375C13.6915 5.85943 12.8896 7.1875 11.7578 7.1875C12.8894 7.1875 13.6915 8.51575 13.6915 10C13.6915 8.51575 14.4935 7.1875 15.6252 7.1875C14.4935 7.1875 13.6915 5.85943 13.6915 4.375Z'
                    fill='white'
                />
            </g>
        </g>
        <path
            d='M21.8857 14H20.2379L22.7486 6.72727H24.7301L27.2372 14H25.5895L23.7678 8.3892H23.7109L21.8857 14ZM21.7827 11.1413H25.6747V12.3416H21.7827V11.1413ZM29.6502 6.72727V14H28.1126V6.72727H29.6502ZM33.2298 14V6.72727H36.0991C36.6507 6.72727 37.1206 6.83262 37.5089 7.04332C37.8971 7.25166 38.1931 7.54167 38.3967 7.91335C38.6026 8.28267 38.7056 8.70881 38.7056 9.19176C38.7056 9.67472 38.6014 10.1009 38.3931 10.4702C38.1848 10.8395 37.8829 11.1271 37.4876 11.3331C37.0946 11.5391 36.6187 11.642 36.06 11.642H34.2312V10.4098H35.8114C36.1074 10.4098 36.3512 10.3589 36.543 10.2571C36.7371 10.1529 36.8815 10.0097 36.9762 9.82741C37.0733 9.64276 37.1218 9.43087 37.1218 9.19176C37.1218 8.95028 37.0733 8.73958 36.9762 8.55966C36.8815 8.37737 36.7371 8.23651 36.543 8.13707C36.3488 8.03527 36.1026 7.98438 35.8043 7.98438H34.7674V14H33.2298ZM42.0526 14.1065C41.5009 14.1065 41.0239 13.9893 40.6214 13.755C40.2214 13.5182 39.9124 13.1892 39.6946 12.7678C39.4768 12.344 39.3679 11.8527 39.3679 11.294C39.3679 10.7306 39.4768 10.2382 39.6946 9.81676C39.9124 9.39299 40.2214 9.06392 40.6214 8.82955C41.0239 8.5928 41.5009 8.47443 42.0526 8.47443C42.6042 8.47443 43.08 8.5928 43.4801 8.82955C43.8826 9.06392 44.1927 9.39299 44.4105 9.81676C44.6283 10.2382 44.7372 10.7306 44.7372 11.294C44.7372 11.8527 44.6283 12.344 44.4105 12.7678C44.1927 13.1892 43.8826 13.5182 43.4801 13.755C43.08 13.9893 42.6042 14.1065 42.0526 14.1065ZM42.0597 12.9347C42.3106 12.9347 42.5201 12.8636 42.6882 12.7216C42.8563 12.5772 42.983 12.3807 43.0682 12.1321C43.1558 11.8835 43.1996 11.6006 43.1996 11.2834C43.1996 10.9661 43.1558 10.6832 43.0682 10.4347C42.983 10.1861 42.8563 9.98958 42.6882 9.84517C42.5201 9.70076 42.3106 9.62855 42.0597 9.62855C41.8063 9.62855 41.5933 9.70076 41.4205 9.84517C41.25 9.98958 41.121 10.1861 41.0334 10.4347C40.9482 10.6832 40.9055 10.9661 40.9055 11.2834C40.9055 11.6006 40.9482 11.8835 41.0334 12.1321C41.121 12.3807 41.25 12.5772 41.4205 12.7216C41.5933 12.8636 41.8063 12.9347 42.0597 12.9347ZM46.6602 14L45.1758 8.54545H46.7063L47.5515 12.2102H47.6012L48.4819 8.54545H49.984L50.8789 12.1889H50.9251L51.756 8.54545H53.283L51.8022 14H50.2006L49.2631 10.5696H49.1957L48.2582 14H46.6602ZM56.4391 14.1065C55.878 14.1065 55.3951 13.9929 54.9902 13.7656C54.5878 13.536 54.2776 13.2116 54.0598 12.7926C53.842 12.3712 53.7331 11.8729 53.7331 11.2976C53.7331 10.7365 53.842 10.2441 54.0598 9.82031C54.2776 9.39654 54.5842 9.06629 54.9796 8.82955C55.3773 8.5928 55.8437 8.47443 56.3787 8.47443C56.7386 8.47443 57.0736 8.53243 57.3837 8.64844C57.6962 8.76207 57.9685 8.93371 58.2005 9.16335C58.4348 9.39299 58.6171 9.68182 58.7473 10.0298C58.8775 10.3755 58.9426 10.7803 58.9426 11.2443V11.6598H54.3368V10.7223H57.5186C57.5186 10.5045 57.4713 10.3116 57.3766 10.1435C57.2819 9.97538 57.1505 9.84399 56.9824 9.74929C56.8167 9.65223 56.6238 9.60369 56.4036 9.60369C56.1739 9.60369 55.9703 9.65696 55.7928 9.76349C55.6176 9.86766 55.4803 10.0085 55.3809 10.1861C55.2814 10.3613 55.2305 10.5566 55.2282 10.772V11.6634C55.2282 11.9332 55.2779 12.1664 55.3773 12.3629C55.4791 12.5594 55.6223 12.7109 55.807 12.8175C55.9917 12.924 56.2106 12.9773 56.464 12.9773C56.632 12.9773 56.7859 12.9536 56.9256 12.9062C57.0653 12.8589 57.1848 12.7879 57.2843 12.6932C57.3837 12.5985 57.4595 12.4825 57.5115 12.3452L58.9107 12.4375C58.8397 12.7737 58.6941 13.0672 58.4739 13.3182C58.2561 13.5668 57.9744 13.7609 57.6287 13.9006C57.2855 14.0379 56.8889 14.1065 56.4391 14.1065ZM59.9299 14V8.54545H61.3965V9.49716H61.4533C61.5527 9.15862 61.7196 8.90294 61.954 8.73011C62.1884 8.55492 62.4583 8.46733 62.7637 8.46733C62.8394 8.46733 62.9211 8.47206 63.0087 8.48153C63.0963 8.491 63.1732 8.50402 63.2395 8.5206V9.86293C63.1685 9.84162 63.0703 9.82268 62.9448 9.80611C62.8193 9.78954 62.7045 9.78125 62.6003 9.78125C62.3778 9.78125 62.1789 9.82978 62.0037 9.92685C61.8309 10.0215 61.6936 10.1541 61.5918 10.3246C61.4924 10.495 61.4426 10.6915 61.4426 10.9141V14H59.9299ZM66.2536 14.1065C65.6925 14.1065 65.2095 13.9929 64.8047 13.7656C64.4022 13.536 64.0921 13.2116 63.8743 12.7926C63.6565 12.3712 63.5476 11.8729 63.5476 11.2976C63.5476 10.7365 63.6565 10.2441 63.8743 9.82031C64.0921 9.39654 64.3987 9.06629 64.794 8.82955C65.1918 8.5928 65.6581 8.47443 66.1932 8.47443C66.553 8.47443 66.888 8.53243 67.1982 8.64844C67.5107 8.76207 67.7829 8.93371 68.0149 9.16335C68.2493 9.39299 68.4316 9.68182 68.5618 10.0298C68.692 10.3755 68.7571 10.7803 68.7571 11.2443V11.6598H64.1513V10.7223H67.3331C67.3331 10.5045 67.2857 10.3116 67.1911 10.1435C67.0964 9.97538 66.965 9.84399 66.7969 9.74929C66.6312 9.65223 66.4382 9.60369 66.218 9.60369C65.9884 9.60369 65.7848 9.65696 65.6072 9.76349C65.4321 9.86766 65.2947 10.0085 65.1953 10.1861C65.0959 10.3613 65.045 10.5566 65.0426 10.772V11.6634C65.0426 11.9332 65.0923 12.1664 65.1918 12.3629C65.2936 12.5594 65.4368 12.7109 65.6214 12.8175C65.8061 12.924 66.0251 12.9773 66.2784 12.9773C66.4465 12.9773 66.6004 12.9536 66.7401 12.9062C66.8797 12.8589 66.9993 12.7879 67.0987 12.6932C67.1982 12.5985 67.2739 12.4825 67.326 12.3452L68.7251 12.4375C68.6541 12.7737 68.5085 13.0672 68.2884 13.3182C68.0705 13.5668 67.7888 13.7609 67.4432 13.9006C67.0999 14.0379 66.7034 14.1065 66.2536 14.1065ZM71.7543 14.0888C71.34 14.0888 70.9647 13.9822 70.6286 13.7692C70.2947 13.5537 70.0296 13.2377 69.8331 12.821C69.639 12.402 69.5419 11.8883 69.5419 11.2798C69.5419 10.6548 69.6425 10.1352 69.8438 9.72088C70.045 9.30421 70.3125 8.9929 70.6463 8.78693C70.9825 8.5786 71.3506 8.47443 71.7507 8.47443C72.0561 8.47443 72.3106 8.52652 72.5142 8.63068C72.7202 8.73248 72.8859 8.86032 73.0114 9.0142C73.1392 9.16572 73.2363 9.31487 73.3026 9.46165H73.3487V6.72727H74.858V14H73.3665V13.1264H73.3026C73.2315 13.2779 73.1309 13.4283 73.0007 13.5774C72.8729 13.7242 72.706 13.8461 72.5 13.9432C72.2964 14.0402 72.0478 14.0888 71.7543 14.0888ZM72.2337 12.8849C72.4775 12.8849 72.6835 12.8187 72.8516 12.6861C73.022 12.5511 73.1522 12.3629 73.2422 12.1214C73.3345 11.88 73.3807 11.5971 73.3807 11.2727C73.3807 10.9484 73.3357 10.6667 73.2457 10.4276C73.1558 10.1884 73.0256 10.0038 72.8551 9.87358C72.6847 9.74337 72.4775 9.67827 72.2337 9.67827C71.9851 9.67827 71.7756 9.74574 71.6051 9.88068C71.4347 10.0156 71.3056 10.2027 71.218 10.4418C71.1304 10.6809 71.0866 10.9579 71.0866 11.2727C71.0866 11.59 71.1304 11.8705 71.218 12.1143C71.308 12.3558 71.437 12.5452 71.6051 12.6825C71.7756 12.8175 71.9851 12.8849 72.2337 12.8849Z'
            fill='white'
        />
        <defs>
            <linearGradient id='label_grad' x1='23.2703' y1='0' x2='40.3862' y2='30.3462' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#843FEF' />
                <stop offset='0.5' stopColor='#A754F7' />
                <stop offset='1' stopColor='#DD4BAE' />
            </linearGradient>
            <clipPath id='label_clip'>
                <rect width='12' height='12' fill='white' transform='translate(4 4)' />
            </clipPath>
        </defs>
    </svg>
);

/* ============================================================
   STANDARD LAYOUT – 2 images + arrow at center + label inside right image
   ============================================================ */
const StandardContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StandardImageLeft = styled.img`
    width: 340px;
    height: 255px;
    object-fit: contain;
    border-radius: 12px;

    @media (max-height: 720px) {
        width: 260px;
        height: 195px;
    }

    @media (max-height: 660px) {
        width: 210px;
        height: 158px;
    }
`;

const StagingImageLeft = styled.img`
    width: 340px;
    height: 255px;
    object-fit: contain;
    border-radius: 12px;
    position: relative;
    right: -70px;

    @media (max-height: 720px) {
        width: 260px;
        height: 195px;
        right: -54px;
    }

    @media (max-height: 660px) {
        width: 210px;
        height: 158px;
        right: -44px;
    }
`;

const StandardRightWrapper = styled.div`
    position: relative;
`;

const StandardImageRight = styled.img`
    width: 340px;
    height: 255px;
    object-fit: cover;
    border-radius: 12px;

    @media (max-height: 720px) {
        width: 260px;
        height: 195px;
    }

    @media (max-height: 660px) {
        width: 210px;
        height: 158px;
    }
`;

const StandardArrow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    flex-shrink: 0;

    svg {
        width: 100%;
        height: auto;
    }

    @media (max-height: 720px) {
        width: 76px;
    }

    @media (max-height: 660px) {
        width: 62px;
    }
`;

const StandardLabel = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
`;

/* ============================================================
   TRYON LAYOUT
   ============================================================ */
const TryonContainer = styled.div`
    position: relative;
    width: 740px;
    height: 340px;
    transform-origin: center;

    @media (max-height: 720px) {
        transform: scale(0.78);
        margin: -37px -81px;
    }

    @media (max-height: 660px) {
        transform: scale(0.63);
        margin: -63px -137px;
    }
`;

const TryonImageFirst = styled.img`
    position: absolute;
    width: 220px;
    height: 220px;
    object-fit: contain;
    border-radius: 10px;
    left: 0px;
    top: 60px;
    z-index: 0;
`;

const TryonArrow = styled.div`
    position: absolute;
    left: 150px;
    top: 160px;
    z-index: 4;
`;

const TryonImageSecond = styled.img`
    position: absolute;
    width: 280px;
    height: 220px;
    object-fit: cover;
    border-radius: 12px;
    left: 250px;
    top: 60px;
    z-index: 1;
`;

const TryonImageThird = styled.img`
    position: absolute;
    width: 280px;
    height: 220px;
    object-fit: cover;
    border-radius: 12px;
    left: 450px;
    top: 85px;
    z-index: 2;
`;

const TryonLabel = styled.div`
    position: absolute;
    left: 550px;
    top: 50px;
    z-index: 5;
`;

/* ============================================================
   SINGLE LAYOUT – one centered image + label
   ============================================================ */
const SingleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SingleImageWrapper = styled.div`
    position: relative;
`;

const SingleImage = styled.img`
    width: 420px;
    height: auto;
    border-radius: 12px;

    @media (max-height: 720px) {
        width: 320px;
    }

    @media (max-height: 660px) {
        width: 260px;
    }
`;

const SingleLabel = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
`;

/* ============================================================
   CONFIG
   ============================================================ */
interface ToolImageConfig {
    leftImage?: string;
    rightImage?: string;
    centerImage?: string;
    layout: 'standard' | 'tryon' | 'single';
}

const TOOL_IMAGES: Record<ToolType, ToolImageConfig> = {
    'virtual-tryon': {
        leftImage: tryon1,
        centerImage: tryon3,
        rightImage: tryon2,
        layout: 'tryon'
    },
    'magic-swap': {
        leftImage: magicSwap1,
        rightImage: magicSwap2,
        layout: 'standard'
    },
    'product-staging': {
        leftImage: staging1,
        centerImage: staging2,
        rightImage: staging3,
        layout: 'tryon'
    },
    'multi-image-fusion': {
        leftImage: multiFusion1,
        rightImage: multiFusion2,
        layout: 'standard'
    },
    'ad-generator': {
        leftImage: adGenerator1,
        rightImage: adGenerator2,
        layout: 'standard'
    },
    'video-generation': {
        leftImage: videoGenerator1,
        rightImage: videoGenerator2,
        layout: 'standard'
    },
    upscaler: {
        centerImage: upscaler1,
        layout: 'single'
    },
    'text-to-3d': {
        leftImage: textTo3dLeft,
        rightImage: textTo3dRight,
        layout: 'standard'
    },
    'image-to-3d': {
        leftImage: imageTo3dLeft,
        rightImage: imageTo3dRight,
        layout: 'standard'
    },
    'multi-views-to-3d': {
        leftImage: multiViewTo3dLeft,
        rightImage: multiViewTo3dRight,
        layout: 'standard'
    }
};

interface ToolEmptyStateImageProps {
    toolId: ToolType;
}

export const ToolEmptyStateImage: FC<ToolEmptyStateImageProps> = ({ toolId }) => {
    const imageConfig = TOOL_IMAGES[toolId];

    if (!imageConfig) {
        return null;
    }

    if (imageConfig.layout === 'single') {
        return (
            <SingleContainer>
                <SingleImageWrapper>
                    <SingleImage src={imageConfig.centerImage} alt='' loading='lazy' />
                    <SingleLabel>
                        <LabelAi />
                    </SingleLabel>
                </SingleImageWrapper>
            </SingleContainer>
        );
    }

    if (imageConfig.layout === 'tryon') {
        return (
            <TryonContainer>
                <TryonImageFirst src={imageConfig.leftImage} alt='' loading='lazy' />
                <TryonArrow>
                    <ArrowTryon />
                </TryonArrow>
                {imageConfig.centerImage && <TryonImageSecond src={imageConfig.centerImage} alt='' loading='lazy' />}
                <TryonImageThird src={imageConfig.rightImage} alt='' loading='lazy' />
                <TryonLabel>
                    <LabelAi />
                </TryonLabel>
            </TryonContainer>
        );
    }

    let LeftImageComponent = StandardImageLeft;
    let RightImageComponent = StandardImageRight;
    let ArrowComponent = StandardArrow;
    let LabelComponent = StandardLabel;
    let ContainerComponent = StandardContainer;

    if (toolId === 'product-staging') {
        LeftImageComponent = StagingImageLeft;
    }

    return (
        <ContainerComponent>
            <LeftImageComponent src={imageConfig.leftImage} alt='' loading='lazy' />
            <ArrowComponent>
                <ArrowSingle />
            </ArrowComponent>
            <StandardRightWrapper>
                <RightImageComponent src={imageConfig.rightImage} alt='' loading='lazy' />
                <LabelComponent>
                    <LabelAi />
                </LabelComponent>
            </StandardRightWrapper>
        </ContainerComponent>
    );
};
